import React from 'react';
import './Header.css';
import FileNameBox from '../FileNameBox/FileNameBox';
import TogglePreview from './TogglePreview/TogglePreview';
import LinksAndCurrentLocation from '../../components/LinksAndCurrentLocation/LinksAndCurrentLocation';

//mobile desktop toggle is disabled until mobile previews are added



const Header = ({ isDragStarted, templateName, onTemplateNameChange, isPreviewOn, handleTogglePreview, openInstruction, prevChange, forwardChange, disablePrev, disableForward }) => {
    return (

    <header className="header">

            <div className="header__group">
                <FileNameBox value={templateName} onChange={onTemplateNameChange} />
            
            </div>

            <React.Fragment>
            <div className='header__option'>
                <LinksAndCurrentLocation isDragStarted={isDragStarted} />
            </div>
        </React.Fragment>

        <TogglePreview prevChange={prevChange} disablePrev={disablePrev} forwardChange={forwardChange} disableForward={disableForward} isPreviewOn={isPreviewOn} onClick={handleTogglePreview} openInstruction={openInstruction}/> 
    </header>
    );
};

export default Header;
